import React from 'react';
import {
  CategoryCarousel,
  CategoryCarouselProps,
  CategoryCarouselPropsCard,
  Control,
} from '@noths/polaris-client-ribbons-design-system';

import { CategoryCarouselCategorySerializedData } from '../../../content/sections/categoryCarousel/types';
import { trackCarouselNavigation } from '../../../tracking/common/carousel';
import { trackItemsImpression } from '../../../tracking/common/trackItemsImpression';
import { trackLinkClick } from '../../../tracking/common/trackLinkClick';
import { TrackingContext } from '../../../types/TrackingContext';
import { setFeaturedProductParamOnURL } from '../../../utils/setFeaturedProductParamOnURL';
import { SectionContainer } from '../../molecules/SectionContainer/SectionContainer';
import * as styles from './CategoryCarouselSection.style';

export interface CategoryCarouselSectionProps extends Omit<CategoryCarouselProps, 'categories'> {
  trackingTitle: string;
  trackingPosition?: number;
  categories: CategoryCarouselCategorySerializedData[];
}

export const CategoryCarouselSection = ({
  trackingTitle,
  trackingPosition,
  categories,
  title,
}: CategoryCarouselSectionProps) => {
  const trackingContext: TrackingContext = {
    trackingPosition,
    trackingTitle,
    trackingContentType: 'Category carousel',
  };

  return (
    <SectionContainer wrapperStyles={styles.wrapper} maxWidth="max" columnsXL={10}>
      <CategoryCarousel
        title={title}
        categories={categories}
        onVisible={() => {
          if (categories.length > 0) {
            trackItemsImpression({
              ...trackingContext,
              numberOfItems: categories.length,
            });
          }
        }}
        onCategoryClick={(e, { index }) => {
          const { categoryName, productCode } = categories[index];

          e.currentTarget.href = setFeaturedProductParamOnURL(e.currentTarget.href, productCode);

          trackLinkClick(e, {
            ...trackingContext,
            link: {
              index,
              name: categoryName,
              href: e.currentTarget.href,
            },
            numberOfItems: categories.length,
            actionName: 'Category click',
          });
        }}
        onNavigation={(swiped: boolean, control: Control) => {
          const direction = control === 'next' ? 'next' : 'previous';

          trackCarouselNavigation(swiped, direction, {
            ...trackingContext,
            numberOfItems: categories.length,
          });
        }}
      />
    </SectionContainer>
  );
};

export type { CategoryCarouselProps, Control, CategoryCarouselPropsCard };
